import './EditModal.css';
import icon_ai from '../assets/actions/icon_ai.png';
import { AIGenerateModal } from './AIGenerateModal';
import { useState } from 'react';

export const EditModal = ({
  type,
  show,
  onClose,
  onConfirm,
  title,
  children,
  onPartialGenerate,
  onGenerate,
  isGenerating = false,
}) => {
  const [showAIModal, setShowAIModal] = useState(false);

  if (!show) {
    return null;
  }

  const handleIconAiClick = () => {
    setShowAIModal(true);
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal edit-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>
              {title}
              {type !== 'story' && (
                <img
                  src={icon_ai}
                  height="30"
                  width="30"
                  alt="icon_ai"
                  style={{ marginLeft: '10px', cursor: 'pointer' }}
                  onClick={handleIconAiClick}
                />
              )}
            </h2>
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-buttons">
            <button
              className="button button-grey"
              onClick={onClose}
              disabled={isGenerating}
            >
              Cancelar
            </button>
            <button
              className={`button button-green ${isGenerating ? 'button-loading' : ''}`}
              onClick={onConfirm}
              disabled={isGenerating}
            >
              {isGenerating ? (
                <span className="dots-loading">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              ) : (
                'Guardar'
              )}
            </button>
          </div>
        </div>
      </div>

      <AIGenerateModal
        type={type}
        show={showAIModal}
        onClose={() => setShowAIModal(false)}
        onGenerate={onGenerate}
        onPartialGenerate={onPartialGenerate}
      />
    </>
  );
};
